export default () => {
  const searchTrigger = document.querySelector('.js-search-trigger');
  const searchClose = document.querySelector('.js-search-panel-close');
  const searchPanel = document.querySelector('.js-search-panel');

  let allHtml = document.querySelector('html');

  if (searchPanel) {
    if (searchTrigger) {
      searchTrigger.addEventListener('click', e => {
        e.preventDefault();
        allHtml.style.overflow = 'hidden';
        document.body.classList.add('is-search-open');
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', e => {
        e.preventDefault();
        allHtml.style.overflow = 'auto';
        document.body.classList.remove('is-search-open');
      });

      document.addEventListener('keyup', e => {
        if ((e.keyCode === 27 || e.key === 'Escape') && document.body.classList.contains('is-search-open')) {
          document.body.classList.remove('is-search-open');
        }
      })
    }
  }
}